import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import base_resources from './base'
import baseCAFlow_resources from './base-ca-flow'
import baseFRFlow_resources from './base-fr-flow'
import baseUSFlow_resources from './base-us-flow'
import cle_ca_resources from './cle-ca'
import ebd_us_resources from './ebd-us'
import fde_us_resources from './fde-us'
import gdo_fr_resources from './gdo-fr'
import gop_fr_resources from './gop-fr'
import lcr_ca_resources from './lcr-ca'
import nua_us_resources from './nua-us'
import oak_ca_resources from './oak-ca'
import oak_us_resources from './oak-us'
import vde_fr_resources from './vde-fr'
import lcr_us_resources from './lcr-us'

const lang = 'en'

const resources = {
  en: {
    translation: {
      ...base_resources.en,
    },
    // fallback namespaces for CA/VD/FR flows take precedence over default translation namespace
    translation_ca: {
      ...baseCAFlow_resources.en,
    },
    translation_us: {
      ...baseUSFlow_resources.en,
    },
    translation_fr: {
      ...baseFRFlow_resources.en,
    },
    'cle-ca': {
      ...cle_ca_resources.en,
    },
    'lcr-ca': {
      ...lcr_ca_resources.en,
    },
    'lcr-us': {
      ...lcr_us_resources.en,
    },
    'vde-fr': {
      ...vde_fr_resources.en,
    },
    'nua-us': {
      ...nua_us_resources.en,
    },
    'fde-us': {
      ...fde_us_resources.en,
    },
    'ebd-us': {
      ...ebd_us_resources.en,
    },
    'gdo-fr': {
      ...gdo_fr_resources.en,
    },
    'gop-fr': {
      ...gop_fr_resources.en,
    },
    'oak-us': {
      ...oak_us_resources.en,
    },
    'oak-ca': {
      ...oak_ca_resources.en,
    },
  },
  fr: {
    translation: {
      ...base_resources.fr,
    },
    translation_ca: {
      ...baseCAFlow_resources.fr,
    },
    translation_us: {
      ...baseUSFlow_resources.en,
    },
    translation_fr: {
      ...baseFRFlow_resources.fr,
    },
    'cle-ca': {
      ...cle_ca_resources.fr,
    },
    'lcr-ca': {
      ...lcr_ca_resources.fr,
    },
    'lcr-us': {
      ...lcr_us_resources.en,
    },
    'vde-fr': {
      ...vde_fr_resources.fr,
    },
    'nua-us': {
      ...nua_us_resources.en,
    },
    'fde-us': {
      ...fde_us_resources.en,
    },
    'ebd-us': {
      ...ebd_us_resources.en,
    },
    'gdo-fr': {
      ...gdo_fr_resources.fr,
    },
    'gop-fr': {
      ...gop_fr_resources.fr,
    },
    'oak-us': {
      ...oak_us_resources.en,
    },
    'oak-ca': {
      ...oak_ca_resources.fr,
    },
  },
}

/**
 * Note: the fallbackNS is modified at runtime in WidgetApp based on the
 * brand locale. For example, for US flow - the fallbackNS will be set to
 *    ['translation_us', 'translation']
 * to give the translations_us namespace higher precedence over the default
 */
i18n.use(initReactI18next).init({
  resources,
  debug: process.env.NODE_ENV === 'development',
  lng: lang,
  fallbackNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
